import { Flex, FlexProps } from "@chakra-ui/core";
import React from "react";

interface BaseWrapperProps extends FlexProps {}
export const PageWidthWrapper: React.FC<BaseWrapperProps> = ({
  children,
  ...rest
}) => {
  return (
    <Flex
      direction="column"
      h="100%"
      w={["100%", "100%", "1440px"]}
      marginX="auto"
      paddingLeft={["20px", "20px", "138px"]}
      paddingRight={["20px", "20px", "138px"]}
      {...rest}
    >
      {children}
    </Flex>
  );
};
